<template>
	<div v-loading="loading">
		<div class="app-container">
			<el-descriptions title="基本信息" :column="2" :size="size" border>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						字号名称
					</template>
					 {{gtdjjbxx.traname}}
				</el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		统一社会信用代码
				 	</template>
				 	 {{gtdjjbxx.uniscid}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		经营者
				 	</template>
				 	 {{gtdjjbxx.opername}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		经营场所
				 	</template>
				 	 {{gtdjjbxx.oploc}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		成立日期
				 	</template>
				 	 {{gtdjjbxx.estdate}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		经营期限
				 	</template>
				 	 {{gtdjjbxx.opfrom}}至{{gtdjjbxx.opto}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px" span=2>
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		经营范围
				 	</template>
				 	 {{gtdjjbxx.busscoandform}}
				 </el-descriptions-item>
				 <el-descriptions-item labelStyle="width:160px">
				 	<template slot="label">
				 		<i class="el-icon-user"></i>
				 		资金数额
				 	</template>
				 	 {{gtdjjbxx.capam}}万
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">
				 		<i class="el-icon-date"></i>
				 		核准日期
				 	</template>
				 	{{ parseTime(gtdjjbxx.apprdate, '{y}年{m}月{d}日') }}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">
				 		<i class="el-icon-s-check"></i>
				 		登记机关
				 	</template>
				 	{{selectDictLabel(regorgOptions,gtdjjbxx.regorg)}}
				 
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">
				 		<i class="el-icon-place"></i>
				 		管辖机关
				 	</template>
				 	{{selectDictLabel(regorgOptions,gtdjjbxx.localadm)}}
				 
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">
				 		<i class="el-icon-notebook-2"></i>
				 		行业门类
				 	</template>
				 	{{selectDictLabel(industryphyOptions,gtdjjbxx.industryphy)}}
				 
				 </el-descriptions-item>
			</el-descriptions>
			<el-descriptions title="经营者信息" :column="2" :size="size" border>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						经营者姓名
					</template>
					 {{gtjyzxx.name}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						性别
					</template>
					 {{gtjyzxx.sex==='1'?'男':'女'}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						出生日期
					</template>
					 {{gtjyzxx.natdate}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						文化程度
					</template>
					 {{selectDictLabel(litedegOptions,gtjyzxx.litedeg)}}
				</el-descriptions-item>
				<el-descriptions-item labelStyle="width:160px">
					<template slot="label">
						<i class="el-icon-user"></i>
						地址
					</template>
					 {{gtjyzxx.dom}}
				</el-descriptions-item>
			</el-descriptions>
			<div class="el-title">变更备案记录</div>
			<el-table v-loading="loading" border :data="bgxxList" ref="tBgxx">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="变更时间" align="center" prop="altdate" width="120" />
				<el-table-column label="变更事项" align="center" prop="invtype" width="120">
					<template slot-scope="scope">
						{{selectDictLabel(altitemOptions,scope.row.altitem)}}
					</template>
				</el-table-column>
				<el-table-column label="变更前内容" align="center" prop="altbe" />
				<el-table-column label="变更后内容" align="center" prop="altaf" />
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :autoScroll=false
				:limit.sync="queryParams.pageSize" @pagination="getGtdjBgsxList" />
			 
		</div>
	</div>
</template>

<script>
	import {
		getGtdjJbxxInfo,
		getGtdjJyzxxInfo,
		listGtdjBgsx,
		 
	} from "@/api/qygzs/yqyd";

	export default {
		name: 'GtdjJbxxDetail',
		props: {
			//个体内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				// 个体登记基本信息
				gtdjjbxx: {},	
			   // 个体经营者信息
			    gtjyzxx: {},	
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,				 
				total: 0,
				// 【变更备案信息】表格数据
				bgxxList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},				 
				size: 'medium ',			
				// 登记机关字典
				regorgOptions: [],
				//企业状态字典
				entstatusOptions: [],
				// 行业门类
				industryphyOptions: [],
				// 行业代码
				industrycoOptions: [],				 
				//变更事项字典
				altitemOptions: [],
				//文化程度字典
				litedegOptions: []


			}
		},
		created() {
			this.init();			
			this.getDicts("fdw_CASEFIAUTH").then(response => {
				this.regorgOptions = response.data;
			});
			this.getDicts("fdw_ENTSTATUS").then(response => {
				this.entstatusOptions = response.data;
			});
			this.getDicts("fdw_INDUSTRYPHY").then(response => {
				this.industryphyOptions = response.data;
			});		  
			this.getDicts("fdw_TRAALTITEM").then(response => {
				this.altitemOptions = response.data;
			});
			this.getDicts("fdw_LITEDEG").then(response => {
				this.litedegOptions = response.data;
			});


		},

		methods: {
			init() {
				this.loading = true;
				this.gtdjjbxx = {},
				this.loadGtdjJbxx();
				this.loadGtdjJyzxx();
				this.getGtdjBgsxList();
				 
			},
			//获取个体基本信息
			loadGtdjJbxx() {
				getGtdjJbxxInfo(this.pripid).then(response => {
					this.gtdjjbxx = response.data;
					this.loading = false;
				});
			},
			 //获取个体经营者信息
			 loadGtdjJyzxx() {
			 	getGtdjJyzxxInfo(this.pripid).then(response => {
			 		this.gtjyzxx = response.data;
			 		this.loading = false;
			 	});
			 },
			// 变更信息
			getGtdjBgsxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listGtdjBgsx(this.queryParams).then(response => {
					this.bgxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});

			},

		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
